import { render, staticRenderFns } from "./Actualizar-producto.vue?vue&type=template&id=04bb7391"
import script from "./Actualizar-producto.vue?vue&type=script&lang=js"
export * from "./Actualizar-producto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports